import { getRequest, postRequest, patchRequest, deleteRequest } from "@react/helpers/fetch"

export const withQuery = (url, params = {}) => {
  const query = new URLSearchParams()
  Object.entries(params).forEach(([key, value]) => {
    if (value !== null && value !== undefined && value !== "") query.set(key, value)
  })
  const qs = query.toString()
  if (!qs) return url
  return `${url}${url.includes("?") ? "&" : "?"}${qs}`
}

const settle = promise =>
  promise
    .catch(() => { throw new Error(I18n.t("project_hours_board.errors.network")) })
    .then(response => {
      if (response && response.error) throw new Error(response.error)
      if (response && response.errors) throw new Error([].concat(response.errors).join(", "))
      return response
    })

export const api = {
  get:    (url, params)       => settle(getRequest(withQuery(url, params))),
  post:   (url, params, body) => settle(postRequest({ url: withQuery(url, params), body })),
  patch:  (url, params, body) => settle(patchRequest({ url: withQuery(url, params), body })),
  delete: (url, params)       => settle(deleteRequest(withQuery(url, params))),
}
